import { useState } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $userCardsStore } from '@lib/store';
import { cn } from '@shared/utils';
import type { UserResponse } from '@shared/api';
import { UserCards } from '../userCards';
import { RemoveCardsModal } from '../modals';
import { AddCardsModal } from '@widgets';
import { Button, Text } from '@shared/widgets';

interface CardsProps {
  className?: string;
  user: UserResponse;
}

export const Cards = (props: CardsProps) => {
  const userCardsStore = useUnit($userCardsStore.store);

  const [showAddCards, setShowAddCards] = useState<boolean>(false);
  const [showRemoveCards, setShowRemoveCards] = useState<boolean>(false);

  const { t } = useTranslation('user');

  return (
    <section className={cn(props.className)}>
      <div className='mb-6 flex flex-wrap items-center justify-between gap-4' title={'Cards' + ` (${userCardsStore.data.data.length})`}>
        <Text weight='medium' size='2xl'>
          {t('cards.title', { count: userCardsStore.data.data.length })}
        </Text>
        <div className='flex items-center gap-3'>
          <Button color='outlined' onClick={() => setShowAddCards(true)}>
            {t('buttons.add', { ns: 'common' })}
          </Button>
          {userCardsStore.data.data.length > 0 && (
            <Button color='outlined' onClick={() => setShowRemoveCards(true)}>
              {t('buttons.remove', { ns: 'common' })}
            </Button>
          )}
        </div>
      </div>
      <UserCards userId={props.user.id} />
      <AddCardsModal
        isOpen={showAddCards}
        onClose={() => setShowAddCards(false)}
        user={props.user}
        cardsItems={userCardsStore.data.data}
        onSubmit={async (data) => $userCardsStore.events.addCards(data)}
      />
      <RemoveCardsModal isOpen={showRemoveCards} user={props.user} onClose={() => setShowRemoveCards(false)} />
    </section>
  );
};
